import { accessTokenKey, fbKey, pushNotificationKey } from '../../../helpers/local-storage';

export const appendHeaders = (headers?: HeadersInit) => {
  const appendableHeaders: Record<string, string> = {
    'Custom-Version': '1.12',
  };
  const accessToken = localStorage.getItem(accessTokenKey);
  if (accessToken) {
    appendableHeaders.Authorization = `Bearer ${accessToken}`;
  }

  const fbToken = localStorage.getItem(fbKey);
  const isNotificationsEnabled =
    'Notification' in window &&
    Notification.permission === 'granted' &&
    !!localStorage.getItem(pushNotificationKey);

  if (fbToken && isNotificationsEnabled) {
    appendableHeaders['Fb-Token'] = fbToken;
  }

  return { ...headers, ...appendableHeaders };
};
